import { render, staticRenderFns } from "./pay-success.vue?vue&type=template&id=30640d16&scoped=true&"
import script from "./pay-success.vue?vue&type=script&lang=js&"
export * from "./pay-success.vue?vue&type=script&lang=js&"
import style0 from "./pay-success.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pay-success.vue?vue&type=style&index=1&id=30640d16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30640d16",
  null
  
)

export default component.exports